import hexRgb from 'hex-rgb';

export function rgb(color) {
    const { red, blue, green } = hexRgb(color);

    return `${red}, ${green}, ${blue}`;
}
